
import { mapState, mapMutations } from "vuex";
import { HundredYears } from "@/graphql/hundredYears";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  components: {
    VueSlickCarousel,
    VueEasyLightbox,
  },
  nuxtI18n: {
    paths: {
      "en-ca": "/our-100-years",
      "fr-ca": "/nos-100-ans",
    },
  },
  async asyncData({ app, i18n, query, error }) {
    const client = app.apolloProvider.defaultClient;
    const locale = i18n.locale.slice(0, 3) + i18n.locale.slice(3).toUpperCase();

    // Check if preview query parameter exists in URL
    const previewMode = query.preview !== undefined ? "PREVIEW" : "LIVE";

    const hundredYearsResponse = await client.query({
      query: HundredYears,
      variables: { locale: locale, preview: previewMode },
    });

    // Return 404 if data is null
    if (
      !hundredYearsResponse.data ||
      !hundredYearsResponse.data.hundredYears.data
    ) {
      return error({ statusCode: 404, message: "Page not found" });
    }

    const page = hundredYearsResponse.data.hundredYears.data.attributes;

    return { page };
  },
  data() {
    return {
      page: {},
      show: false,
      anchorSelected: "",
      historyBlock: {
        currentDate: "",
        prevDate: "",
        nextDate: "",
        title: "",
        text: "",
      },
      secondCarouselBlock: {
        currentSlide: "",
        prevSlide: "",
        nextSlide: "",
        title: "",
        text: "",
      },
      testimonialsBlock: {
        currentSlide: "",
        prevSlide: "",
        nextSlide: "",
        title: "",
        text: "",
      },
      carouselSettings: {
        arrows: false,
        centerMode: true,
        focusOnSelect: true,
        infinite: false,
        centerPadding: "0px",
        variableWidth: true,
        swipe: false,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              swipe: true,
            },
          },
        ],
      },
      slidesNumber: "",
      slidesNumberSecondCarousel: "",
      slidesNumberTestimonials: "",
      lightboxVisible: false,
      lightboxImage: "",
      selectedTab: "first",
    };
  },
  head() {
    return {
      title: this.page.SEO.MetaTitle,
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.page.SEO.MetaDescription,
        },
        {
          hid: "og:description",
          name: "og:description",
          content: this.page.SEO.MetaDescription,
        },
      ],
    };
  },
  mounted() {
    window.scrollTo(0, 0);
    setTimeout(() => this.setPageAnimation("animBanner"), 500);
  },
  computed: {
    ...mapState(["pageScroll"]),
  },
  methods: {
    ...mapMutations({
      setPageAnimation: "SET_PAGE_ANIMATION",
    }),
    handleInit() {
      this.slidesNumber = this.page.FirstCarouselSlides.length;
      this.historyBlock.prevDate = "";
      this.historyBlock.currentDate = this.page.FirstCarouselSlides[0].Year;
      this.historyBlock.nextDate = this.page.FirstCarouselSlides[1].Year;
      this.historyBlock.title = this.page.FirstCarouselSlides[0].Titre;
      this.historyBlock.text = this.page.FirstCarouselSlides[0].Texte;
    },
    handleAfterChange(currentSlide) {
      this.getPreviousDate(currentSlide);
      this.getNextDate(currentSlide);
      this.historyBlock.currentDate =
        this.page.FirstCarouselSlides[currentSlide].Year;
      this.historyBlock.title =
        this.page.FirstCarouselSlides[currentSlide].Titre;
      this.historyBlock.text =
        this.page.FirstCarouselSlides[currentSlide].Texte;
    },
    showPrev() {
      this.$refs.carousel.prev();
    },
    showNext() {
      this.$refs.carousel.next();
    },
    getPreviousDate(currentSlide) {
      if (currentSlide > 0) {
        this.historyBlock.prevDate =
          this.page.FirstCarouselSlides[currentSlide - 1].Year;
      } else {
        this.historyBlock.prevDate = "";
      }
    },
    getNextDate(currentSlide) {
      if (currentSlide != this.slidesNumber - 1) {
        this.historyBlock.nextDate =
          this.page.FirstCarouselSlides[currentSlide + 1].Year;
      } else {
        this.historyBlock.nextDate = "";
      }
    },
    handleInitSecndCarousel() {
      this.slidesNumberSecondCarousel = this.page.SecondCarouselSlides.length;
      this.secondCarouselBlock.prevSlide = "";
      this.secondCarouselBlock.currentSlide =
        this.page.SecondCarouselSlides[0].Title;
      this.secondCarouselBlock.nextSlide =
        this.page.SecondCarouselSlides.length > 1
          ? this.page.SecondCarouselSlides[1].Title
          : "";
      this.secondCarouselBlock.text = this.page.SecondCarouselSlides[0].Text;
    },
    handleAfterChangeSecondCarousel(currentSlide) {
      this.getPreviousSlideSecondCarousel(currentSlide);
      this.getNextSlideSecondCarousel(currentSlide);
      this.secondCarouselBlock.currentSlide =
        this.page.SecondCarouselSlides[currentSlide].Title;
      this.secondCarouselBlock.text =
        this.page.SecondCarouselSlides[currentSlide].Text;
    },
    showPrevSecondCarousel() {
      this.$refs.secondCarousel.prev();
    },
    showNextSecondCarousel() {
      this.$refs.secondCarousel.next();
    },
    getPreviousSlideSecondCarousel(currentSlide) {
      if (
        currentSlide > 0 &&
        this.page.SecondCarouselSlides &&
        this.page.SecondCarouselSlides[currentSlide - 1]
      ) {
        this.secondCarouselBlock.prevSlide =
          this.page.SecondCarouselSlides[currentSlide - 1].Title;
      } else {
        this.secondCarouselBlock.prevSlide = "";
      }
    },
    getNextSlideSecondCarousel(currentSlide) {
      if (
        currentSlide != this.slidesNumberSecondCarousel - 1 &&
        this.page.SecondCarouselSlides &&
        this.page.SecondCarouselSlides[currentSlide + 1]
      ) {
        this.secondCarouselBlock.nextSlide =
          this.page.SecondCarouselSlides[currentSlide + 1].Title;
      } else {
        this.secondCarouselBlock.nextSlide = "";
      }
    },

    handleInitTestimonials() {
      this.slidesNumberTestimonials = this.page.Testimonials.length;
      this.testimonialsBlock.prevSlide = "";
      this.testimonialsBlock.currentSlide = this.page.Testimonials[0].Name;
      this.testimonialsBlock.nextSlide =
        this.page.Testimonials.length > 1 ? this.page.Testimonials[1].Name : "";
      this.testimonialsBlock.text = this.page.Testimonials[0].Text;
    },
    handleAfterChangeTestimonials(currentSlide) {
      this.getPreviousSlideTestimonials(currentSlide);
      this.getNextSlideTestimonials(currentSlide);
      this.testimonialsBlock.currentSlide =
        this.page.Testimonials[currentSlide].Name;
      this.testimonialsBlock.text = this.page.Testimonials[currentSlide].Text;
    },
    showPrevTestimonials() {
      this.$refs.testimonials.prev();
    },
    showNextTestimonials() {
      this.$refs.testimonials.next();
    },
    getPreviousSlideTestimonials(currentSlide) {
      if (
        currentSlide > 0 &&
        this.page.Testimonials &&
        this.page.Testimonials[currentSlide - 1]
      ) {
        this.testimonialsBlock.prevSlide =
          this.page.Testimonials[currentSlide - 1].Name;
      } else {
        this.testimonialsBlock.prevSlide = "";
      }
    },
    getNextSlideTestimonials(currentSlide) {
      if (
        currentSlide != this.slidesNumberTestimonials - 1 &&
        this.page.Testimonials &&
        this.page.Testimonials[currentSlide + 1]
      ) {
        this.testimonialsBlock.nextSlide =
          this.page.Testimonials[currentSlide + 1].Name;
      } else {
        this.testimonialsBlock.nextSlide = "";
      }
    },
    getYouTubeId(input) {
      // Return null if input is invalid
      if (!input || typeof input !== "string") return null;

      // Regular expression to find the ID within various YouTube URL formats
      // This covers: standard watch URLs, shortened youtu.be URLs, and embeds
      const regExp =
        /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
      const match = input.match(regExp);

      // 1. Check if it matches a URL pattern and extracts an 11-character ID
      if (match && match[2].length === 11) {
        return match[2];
      }

      // 2. Fallback: Check if the input itself is just the 11-character ID
      // A valid YouTube ID consists of alphanumeric characters, hyphens, and underscores
      const idPattern = /^[a-zA-Z0-9_-]{11}$/;
      if (idPattern.test(input)) {
        return input;
      }

      // Return null if no valid ID could be determined
      return null;
    },
    toId(value) {
      if (!value) return "";
      return value
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-"); // Replace multiple - with single -
    },
    showLightbox(url) {
      console.log("Trying to open lightbox with: " + url);
      this.lightboxImage = url;
      this.lightboxVisible = true;
    },
    handleHide() {
      this.lightboxVisible = false;
    },
    selectTab(tab) {
      this.selectedTab = tab === this.selectedTab ? "" : tab;
    },
  },
};
